/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFPrivacyData } from './CRSFPrivacyData';
import {
    CRSFPrivacyDataFromJSON,
    CRSFPrivacyDataFromJSONTyped,
    CRSFPrivacyDataToJSON,
} from './CRSFPrivacyData';

/**
 * 
 * @export
 * @interface CRSFPrivacyResultItem
 */
export interface CRSFPrivacyResultItem {
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyResultItem
     */
    asset: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFPrivacyResultItem
     */
    created: number;
    /**
     * 
     * @type {CRSFPrivacyData}
     * @memberof CRSFPrivacyResultItem
     */
    data: CRSFPrivacyData;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyResultItem
     */
    domain_origination?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyResultItem
     */
    ext_type?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFPrivacyResultItem
     */
    found?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyResultItem
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFPrivacyResultItem
     */
    source_asset: string;
}

/**
 * Check if a given object implements the CRSFPrivacyResultItem interface.
 */
export function instanceOfCRSFPrivacyResultItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "source_asset" in value;

    return isInstance;
}

export function CRSFPrivacyResultItemFromJSON(json: any): CRSFPrivacyResultItem {
    return CRSFPrivacyResultItemFromJSONTyped(json, false);
}

export function CRSFPrivacyResultItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPrivacyResultItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'created': json['created'],
        'data': CRSFPrivacyDataFromJSON(json['data']),
        'domain_origination': !exists(json, 'domain_origination') ? undefined : json['domain_origination'],
        'ext_type': !exists(json, 'ext_type') ? undefined : json['ext_type'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'process_id': json['process_id'],
        'source_asset': json['source_asset'],
    };
}

export function CRSFPrivacyResultItemToJSON(value?: CRSFPrivacyResultItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'created': value.created,
        'data': CRSFPrivacyDataToJSON(value.data),
        'domain_origination': value.domain_origination,
        'ext_type': value.ext_type,
        'found': value.found,
        'process_id': value.process_id,
        'source_asset': value.source_asset,
    };
}

